import { rest } from 'msw'

import { config } from '@percent/admin-dashboard/config'
import { mockAccountResponse } from '@percent/admin-dashboard/fixtures/api/mockAccountResponse'
import { AccountStatus, mockAccountsData } from '@percent/domain/iam'

export const accountsHandlers = [
  rest.get(`${config.urls.api}v1/admin/iam/accounts/:accountId`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockAccountResponse))
  }),
  rest.get(`${config.urls.api}v1/admin/iam/accounts`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockAccountsData))
  }),
  rest.get(`${config.urls.api}v1/account`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockAccountResponse))
  }),
  rest.post(`${config.urls.api}v1/admin/iam/accounts/invite`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json({ success: true }))
  }),
  rest.post(`${config.urls.api}v1/admin/iam/accounts/:accountId/2fa/temp-backup-code`, async (req, res, ctx) => {
    return res(ctx.status(200))
  }),
  rest.post(`${config.urls.api}v1/admin/iam/accounts/:accountId/admin`, async (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        ...mockAccountResponse,
        data: { ...mockAccountResponse.data, status: AccountStatus.removed, admin: '2025-01-01T00:00:00Z' }
      })
    )
  }),
  rest.delete(`${config.urls.api}v1/admin/iam/accounts/:accountId`, async (_, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({ ...mockAccountResponse, data: { ...mockAccountResponse.data, deletedAt: new Date().toISOString() } })
    )
  }),
  rest.post(`${config.urls.api}v1/admin/iam/accounts/:accountId/redact`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json({ success: true }))
  }),
  rest.post(`${config.urls.api}v1/admin/iam/accounts/:accountId/reactivate`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json({ success: true }))
  })
]
